import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import useViewportHeight from "../../hooks/useViewportHeight";
import useInterval from "../../hooks/useInterval";
import { getNotificationsInfo } from "../../services/ApiService";
import useStateRef from "../../hooks/useStateRef";
export const AppContext = /*#__PURE__*/React.createContext({});
const DixuApp = _ref => {
  let {
    user,
    children
  } = _ref;
  const mountedRef = useRef(false);
  const [context, setContext, contextRef] = useStateRef({
    user,
    notifications: {
      unreadMessages: 0,
      unseenPurchaseOffers: 0,
      total: 0
    }
  });
  useViewportHeight({
    cssVariableName: 'dixu-app-viewport-height'
  });
  const updateContext = useCallback(data => {
    return setContext(prevState => {
      return _objectSpread(_objectSpread({}, prevState), data);
    });
  }, []);
  const updateNotifications = useCallback(async () => {
    if (user) {
      try {
        const {
          unreadMessagesCount,
          unseenPurchaseOffersCount,
          totalNotificationsCount
        } = await getNotificationsInfo();
        updateContext({
          notifications: _objectSpread(_objectSpread({}, contextRef.current.notifications), {}, {
            unreadMessages: unreadMessagesCount || 1,
            unseenPurchaseOffers: unseenPurchaseOffersCount,
            total: totalNotificationsCount
          })
        });
      } catch (error) {
        console.error(error);
      }
    }
  }, []);
  useEffect(() => {
    if (mountedRef.current) {
      updateContext({
        user
      });
    } else {
      mountedRef.current = true;
    }
  }, [user]);

  // TODO maybe enable or might be better to just update on route change
  // useInterval(updateNotifications, 60 * 1000);

  const contextValue = _objectSpread(_objectSpread({}, context), {}, {
    updateContext
  });
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: contextValue
  }, children);
};
DixuApp.defaultProps = {
  user: undefined
};
export default DixuApp;